import React, { useEffect, useState } from "react"
import { download, getFormattedDate, round2Digits, spacedNum } from "../../../common/CommonHelper"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { CommonInput } from "../../../common/element/fields/CommonInput"
import { CommonFileList } from "../../../common/element/fields/CommonFileList"
import Button from "@/ui/components/Button"
import { ModalConfirm } from "@/components/common/element/ModalConfirm"
import {
  ICurrencyReplenishmentCredit,
  ICurrencyReplenishmentDto
} from "@/types/replenishment/ICurrencyReplenishmentDto"
import { ReplenishmentErrorBlock } from "./ReplenishmentErrorBlock"
import { IMG } from "@/components/common/CONST"

export const PaymentCheckTab: React.FC<{
  replenishment: ICurrencyReplenishmentDto
  setReplenishment: (r: ICurrencyReplenishmentDto) => void
}> = ({ replenishment, setReplenishment }) => {
  const [message, setMessage] = useState<IModalMessage | null>(null)
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [creditData, setCreditData] = useState<ICurrencyReplenishmentCredit>({
    id: replenishment.id || 0,
    incomeAmount: round2Digits(Number(replenishment.incomeAmount || replenishment.invoiceAmount) / 100).toString(),
    commissionPercent: replenishment.commissionPercent?.toString() || "0",
    commissionAmount: replenishment.commissionAmount
      ? round2Digits(replenishment.commissionAmount / 100).toString()
      : "0",
    creditedAmount: replenishment.creditedAmount ? round2Digits(replenishment.creditedAmount / 100).toString() : "0"
  })
  const [isAccepting, setIsAccepting] = useState(false)

  const setAmount = (val: string | undefined) => {
    setCreditData({ ...creditData, incomeAmount: val || "" })
  }

  const setComissionAmount = (val: string | undefined) => {
    setCreditData({ ...creditData, commissionAmount: val || "" })
  }

  const setComissionPercent = (val: string | undefined) => {
    setCreditData({ ...creditData, commissionPercent: val || "" })
  }

  const getCalculationRequestPrepared = (source: ICurrencyReplenishmentCredit): ICurrencyReplenishmentCredit => {
    const prepared = { ...source }

    const commissionAmount = Number(prepared.commissionAmount?.toString().replaceAll(" ", "")) * 100
    const commissionPercent = Number(prepared.commissionPercent?.toString().replaceAll(" ", ""))

    prepared.incomeAmount = prepared.incomeAmount
      ? (Number(prepared.incomeAmount?.toString().replaceAll(" ", "")) * 100).toString()
      : "0"
    prepared.commissionAmount = commissionAmount > 0 ? commissionAmount.toString() : null
    prepared.commissionPercent = commissionPercent > 0 ? commissionPercent.toString() : null
    prepared.creditedAmount = prepared.creditedAmount
      ? (Number(prepared.creditedAmount?.toString().replaceAll(" ", "")) * 100).toString()
      : "0"
    return prepared
  }

  const acceptPaymentOrder = () => {
    if (Number(creditData.incomeAmount) < 0) {
      setMessage({ title: "Ошибка!", text: "Сумма не может быть меньше нуля" })
      return
    }

    setIsAccepting(true)

    TrinityAPI.acceptCurrencyPayment(
      getCalculationRequestPrepared(creditData),
      response => {
        if (response.status === 200) {
          window.location.reload()
        } else {
          setMessage({ title: "Ошибка", text: `Ошибка подтверждения оплаты: ${response.data.message}` })
        }
      },
      () => setIsAccepting(false)
    )
  }

  useEffect(() => {
    if (creditData.incomeAmount) {
      TrinityAPI.calculateCurrencyReplenishment(getCalculationRequestPrepared(creditData), response => {
        if (response.status === 200 && response.data.creditedAmount) {
          setCreditData(prev => ({
            ...prev,
            creditedAmount: spacedNum(Number(response.data.creditedAmount) / 100).toString()
          }))
        } else {
          setMessage({ title: "Ошибка", text: `Ошибка подсчета суммы к пополнению: ${response.data.message}` })
        }
      })
    }
  }, [creditData.incomeAmount, creditData.commissionAmount, creditData.commissionPercent])

  return (
    <>
      <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
      <ModalPopUp message={message} close={() => setMessage(null)} />
      <div className="container">
        <div className="container-pop-up">
          <ul className="form-left">
            <li className="form-block-popup">
              <h4 className="heading-chapter">Информация об оплате</h4>
              <>
                <p className="message-course-yes">
                  {replenishment.status === "DONE"
                    ? "Оплата подтверждена"
                    : "Клиент оплатил счет и загрузил платежное поручение. Проверьте документы и\n" +
                      "                          нажмите\n" +
                      "                          кнопку\n" +
                      '                          "Подтвердить" если платеж прошел успешно'}
                </p>
                <div className="flex-row-10">
                  <CommonInput
                    disabled={replenishment.status === "DONE"}
                    typeName={"number"}
                    label={"Сумма"}
                    placeholder={""}
                    name={"amount"}
                    value={creditData.incomeAmount}
                    errorModel={undefined}
                    _callback={v => setAmount(v)}
                  />
                  <fieldset className="fieldset-200">
                    <legend>Валюта</legend>
                    <p className="text-form">{replenishment.currencyRequest?.currency}</p>
                  </fieldset>
                </div>

                <div className="flex-row-10">
                  <CommonInput
                    disabled={replenishment.status === "DONE"}
                    typeName={"number"}
                    label={"Комиссия фикс."}
                    placeholder={""}
                    name={"commissionAmount"}
                    value={creditData.commissionAmount || ""}
                    errorModel={undefined}
                    _callback={v => setComissionAmount(v)}
                  />

                  <CommonInput
                    disabled={replenishment.status === "DONE"}
                    typeName={"number"}
                    label={"Комиссия %"}
                    placeholder={""}
                    name={"commissionPercent"}
                    value={creditData.commissionPercent || ""}
                    errorModel={undefined}
                    _callback={v => setComissionPercent(v)}
                  />
                </div>

                <fieldset>
                  <legend>Сумма к пополнению</legend>
                  <p className="text-form">{creditData.creditedAmount}</p>
                </fieldset>

                <CommonFileList downloadableFiles={replenishment.slipFiles} type="CURRENCY_SLIP" />
              </>
            </li>
            <div className="flex-row-10">
              {replenishment.status === "SLIP_SENT" && (
                <Button onClick={acceptPaymentOrder} loading={isAccepting}>
                  Подтвердить
                </Button>
              )}
              {/*<button className="btn grey-btn">Претензия</button>*/}
            </div>
          </ul>
          <ul className="right-form">
            <li className="form-block-popup">
              <h4 className="heading-chapter">Контракт на валютное пополнение</h4>
              <div className="flex-row-10">
                <fieldset>
                  <legend>Дата</legend>
                  <p className="text-form">{getFormattedDate(replenishment.contractDate || "")}</p>
                </fieldset>
                <fieldset>
                  <legend>Номер</legend>
                  <p className="text-form">№{replenishment.contractNumber}</p>
                </fieldset>
                <fieldset className="fieldset-fit">
                  <legend>Контракт</legend>
                  <button
                    className="btn download-btn"
                    onClick={() => download(replenishment.id?.toString(), "CLIENT_CURRENCY_CONTRACT")}
                  >
                    <img src={IMG.download} alt="" />
                    Скачать
                  </button>
                </fieldset>
              </div>
              <ReplenishmentErrorBlock
                replenishment={replenishment}
                setReplenishment={setReplenishment}
                fieldName={"contractComment"}
              />
            </li>

            <li className="form-block-popup">
              <h4 className="heading-chapter">Счет</h4>
              <div className="flex-row-10">
                <button
                  className="btn black-btn"
                  onClick={() => window.open(`/currency-replenishment/${replenishment.id}/bill`)}
                >
                  Открыть счет
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
